import {
    contributeAiCapabilityParamOption,
    declareAiCapability,
    provideAiCapability
} from "@medflyt/webapp-react/src/modules/ai-omnibar/ai-capability-registry";

/**
 * Opening a report by name, described by the page that holds the list.
 *
 * The enum has no options here on purpose: the reports are agency records, fetched when this page
 * loads, and there is no list to write down at import time. The page contributes them below while it
 * is on screen, which is also what makes the matching work - the browser matches a name it was given
 * exactly and for nothing else asks the value search, so "caregiver overtime" costs nothing and
 * "weekly hours" costs one call.
 *
 * `scope: "page"` because that is the space `app.navigate` opens, so "open the caregiver overtime
 * report" comes back as navigate-then-open with the ordering derived rather than written down.
 */
declareAiCapability({
    id: "standardReport.open",
    title: "Open a standard report",
    effect: "navigate",
    description:
        "Opens one of the agency's standard reports on its own page, with the filters it was saved with, ready to run. It does not run it - the person presses Run, sees the rows, and decides what to do with them. Only works from the Reports > Standard page, which is where the list of reports lives.",
    location: "the Reports > Standard list",
    scope: "page",
    // Being on a report's page is what makes its own filters reachable.
    opens: ["standard-report"],
    permissionKey: "view_reports_section_standard",
    params: [
        {
            name: "report",
            type: "enum",
            required: true,
            description: "Which report to open."
        }
    ],
    examples: [
        "open the caregiver overtime report",
        "show me the patients without visits report",
        "standard report for nursing visits due"
    ]
});

//! @ngInject
export function standardReportsCtrl($scope, $rootScope, $state, $uibModal, $filter, NgTableParams, reportService, toaster, SweetAlert) {

    function initialize() {
        $scope.hideReports = false;
        loadItems();
    }

    // Held so the capability's options can be released and republished when the list reloads.
    let releaseReportOptions = [];
    let releaseReportCapability = null;

    const publishReportsToAi = function (reports) {
        releaseReportOptions.forEach((release) => release());
        releaseReportOptions = reports.map((report) =>
            contributeAiCapabilityParamOption("standardReport.open", "report", {
                value: String(report.id),
                label: report.name
            })
        );

        // Provided only now: available before the list arrives would mean a step that fires with
        // nothing to choose from.
        if (releaseReportCapability === null) {
            releaseReportCapability = provideAiCapability("standardReport.open", (args, context) => {
                const report = ($scope.standardReports ?? []).find(
                    (candidate) => String(candidate.id) === String(args.report)
                );

                if (report === undefined) {
                    throw new Error("That report is not in this list.");
                }

                // What clicking the row does, and not optional: the list is wrapped in
                // ng-if="!hideReports", so leaving it false keeps the list on screen with the report
                // mounted underneath - the report opens, and it does not look like it did.
                $scope.hideReports = true;

                $state.go("app.reports.standard.standardReportView", {
                    standardReportId: report.id
                });

                return "Opened " + report.name + " - press Run to generate it";
            });
        }
    };

    $scope.$on("$destroy", function () {
        releaseReportOptions.forEach((release) => release());
        releaseReportOptions = [];

        if (releaseReportCapability !== null) {
            releaseReportCapability();
            releaseReportCapability = null;
        }
    });

    const loadItems = function () {
        $scope.hideReports = false;
        reportService.getStandardReports().then(res => {
            $scope.standardReports = res.map(report => ({
                ...report,
                loadingReport: false,
            }));
            initTable($scope.standardReports);
            publishReportsToAi($scope.standardReports);
        });
    }

    const initTable = function (items) {
        const options = {
            count: 25,
        };

        $scope.tableParams = new NgTableParams(options, {
            dataset: items,
        });
    };

    $scope.clickTableRow = (standardReportId) => {
        $scope.hideReports = true;
        $state.go('app.reports.standard.standardReportView', { standardReportId: standardReportId });
    }

    $scope.handleNewReport = () => {
        const mySavedReportsNames = $scope.standardReports.map(report => report.name);
        $state.go('app.reports.reportTool', { mySavedReportsNames });
    }

    var universalBOM = "\uFEFF";


    $scope.handleManageAccess = (savedReport) => {
        const newScope = $scope.$new();
        newScope.standardReport = savedReport;
        $rootScope.openStandardReportPermissionsModal(newScope);
    }

    $scope.applyGlobalSearch = function (term) {
      var filter = { $: term };
      if ($scope.tableParams) {
        angular.extend($scope.tableParams.filter(), filter);
      } else {
        console.log("no table");
      }
    };


    const getFileName = (filename) => {
        return `medflyt-report-${(filename ? filename + "-" : '')}${$filter("date")(new Date(), "yyyy-MM-dd")}.csv`;
    }

    $scope.handleOpenReportEntityPermissionsModal = () => {
        $rootScope.openReportEntityPermissionsModal();
    }
    $scope.hideStandardReport = (standard_report_id) =>{

      reportService.updateStandardReportSettings(standard_report_id,{is_shown: false,standard_report_id: standard_report_id,agency_member_id:$rootScope.user.agencyMember.id}).then(()=>{
        $state.reload();
      });


    }
    $scope.showStandardReport = (standard_report_id) =>{
        reportService.updateStandardReportSettings(standard_report_id,{is_shown: true,standard_report_id: standard_report_id,agency_member_id:$rootScope.user.agencyMember.id}).then(()=>{

        $state.reload();
      });
    }
    $scope.manageStandardReportAccess = (standard_report_id,title) =>{
        // let newScope = angular.copy($scope)
        const newScope = $scope.$new();
        newScope.standardReport ={id:standard_report_id};
        newScope.title = title;
        $rootScope.openStandardReportPermissionsModal(newScope);
    }
    $scope.showHiddenReportsModal = ()=>{

        $rootScope.openStandardReportHiddenModal($scope);
    }

    $scope.handleOpenScheduledStandardReport = function (id, name) {
        const newScope = $scope.$new();
        newScope.standardReportId = id;
        newScope.standardReportName = name;

        return $uibModal.open({
            templateUrl: 'admin/views/scheduled-standard-report-modal.html',
            size: 'lg',
            controller: 'scheduledStandardReportModalCtrl',
            scope: newScope,
            windowClass: 'modal modal-slide-in-right scheduled-reports-container',
            backdrop: 'static',
            keyboard: false
        });
    };

    initialize();

};
